import { createContext, useContext} from "react";

const TableIdContext = createContext(null);

export const useTableId = () => useContext(TableIdContext);

export const TableIdProvider = ({ children, tableId }) => {
  return (
    <TableIdContext.Provider value={tableId}>
      {children}
    </TableIdContext.Provider>
  );
};